import styled from "styled-components";

export default function LayerItem({ title, id, checked, onChange, disabled = false }) {
  return (
    <LayerItemContainer>
      <label htmlFor={id}>
        <input type="checkbox" id={id} name="layer" checked={checked} onChange={onChange} disabled={disabled} />
        <div className="custom-checkbox"></div>
        <span className={checked ? "bold" : ""}>{title}</span>
      </label>
    </LayerItemContainer>
  );
}

const LayerItemContainer = styled.div`
  label {
    display: flex;
    align-items: center;
    gap: 10px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    cursor: pointer;
  }

  label:has(input:disabled) {
    cursor: not-allowed;
  }

  input {
    display: none;
  }

  .custom-checkbox {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid #0f77ffff;
    border-radius: 4px;
    transition: all 0.2s;
  }

  input:checked + .custom-checkbox {
    background-color: #0f77ffff;
    border-color: #0f77ffff;
  }

  input:checked + .custom-checkbox::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -60%) rotate(45deg);
  }

  .bold {
    font-weight: bold;
  }
`;
